import { render, staticRenderFns } from "./PosInventoryList.vue?vue&type=template&id=84a482d2&scoped=true&"
import script from "./PosInventoryList.vue?vue&type=script&lang=js&"
export * from "./PosInventoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a482d2",
  null
  
)

export default component.exports